import React, { useRef, useState, useEffect } from "react";
import contactus from "../src/images/contactus.jpg";
import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import "primeflex/primeflex.css";
import "./App.css";
import { Helmet } from "react-helmet";
import { Card } from "primereact/card";

const Contact = () => {
  const toast = useRef(null);
  const [contactName, setContactName] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [contactSubject, setContactSubject] = useState("");
  const [contactMessage, setContactMessage] = useState("");
  const [contactMobile, setContactMobile] = useState("");

  const sendEmail = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("/saveContactUsEnquiry", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: contactName,
          emailID: contactEmail,
          subject: contactSubject,
          message: contactMessage,
          // mobileNumber: contactMobile,
        }),
      });

      if (response.status === 200) {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Form submitted successfully!",
        });
        setContactName("");
        setContactEmail("");
        setContactSubject("");
        setContactMessage("");
        setContactMobile("");
      } else {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Some Error Occured Try Again Later",
        });
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  return (
    <>
      <Helmet>
        <title>Contact Us | Clota Technology</title>
        <meta
          name="description"
          content="Get in touch with Clota Technology for database update support, queries, and suggestions. We'd love to hear from you!"
        />
        <meta
          name="keywords"
          content="Contact, Clota Technology, Support, Database Help, Queries, Suggestions, Feedback"
        />
        <meta name="author" content="Clota Technology" />
      </Helmet>
      <Toast ref={toast} />
      <section id="contactbox" className="flex align-items-center">
        <div className="w-full px-4 md:px-8 lg:px-6">
          <div className="grid align-items-center">
            {/* Left Side: Text + Image */}
            <div className="col-12 lg:col-6">
              <div className="grid align-items-center">
                <div className="col-12">
                  <h1 className="fs-h1 mb-1">
                    Having doubts?
                    <strong className="brand-name"> Feel free to Ask!!</strong>
                  </h1>
                  <h3 className="fs-h3 mb-2">
                    <b>Thank you for visiting our site</b>
                  </h3>
                  <p className="fs-p mb-2">
                    Our website is a one-stop resource for database update info.
                    If you have any queries or suggestions, feel free to contact
                    us. We will respond as soon as possible.
                  </p>
                </div>
                <div className="col-12 text-center">
                  <img
                    src={contactus}
                    className="img-fluid mb-2 contact-img w-full"
                    alt="Contact us"
                    style={{ borderRadius: "12px", maxWidth: "400px" }}
                  />
                </div>
              </div>
            </div>

            {/* Right Side: Contact Form */}
            <div className="col-12 lg:col-6">
              <hr className="mb-2 lg:hidden" />

              <div className="shadaw-5 mx-auto w-full">
                <h4 className="text-center fs-h3 mb-1">
                  Your Suggestions Below
                </h4>
                <form onSubmit={sendEmail} className="p-fluid p-formgrid grid">
                  <div className="field col-12">
                    <label htmlFor="uid">Your Name</label>
                    <InputText
                      id="uid"
                      name="uid"
                      placeholder="Enter Full Name"
                      required
                      value={contactName}
                      onChange={(e) => setContactName(e.target.value)}
                    />
                  </div>

                  <div className="field col-12">
                    <label htmlFor="emid">Email</label>
                    <InputText
                      id="emid"
                      name="emid"
                      type="email"
                      placeholder="Enter Email"
                      keyfilter="email"
                      required
                      value={contactEmail}
                      onChange={(e) => setContactEmail(e.target.value)}
                    />
                  </div>

                  <div className="field col-12">
                    <label htmlFor="numid">Enquiry About</label>
                    <InputText
                      placeholder="Enquiry About"
                      required
                      value={contactSubject}
                      onChange={(e) => setContactSubject(e.target.value)}
                    />
                  </div>

                  <div className="field col-12">
                    <label htmlFor="txt">Message</label>
                    <InputTextarea
                      id="txt"
                      name="txt"
                      placeholder="Enter Message"
                      rows={4}
                      required
                      value={contactMessage}
                      onChange={(e) => setContactMessage(e.target.value)}
                    />
                  </div>
                  <div className="flex justify-content-center mt-2">
                    <Button
                      type="submit"
                      label="Submit"
                      className="fontclass btn-styles"
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
